module.exports = __webpack_public_path__ + "static/image/sustainability/img-protection-2@3x.ver2_0_2.png?b6e5f73b";